import { AgentPlatformSurface, useAgentProfiles } from '@commenda/api';

import { ComposerProfileMenuHelper } from './composer-profile-menu-helper';

interface ComposerProfileChipProps {
  /** Null is the default chat agent, which is what an unbound conversation runs. */
  profileKey: string | null;
}

/** The agent an open conversation runs as. Static, not a picker: the agent is bound when the
 * conversation is created and the backend cannot change it mid-thread. */
export const ComposerProfileChip = ({
  profileKey,
}: ComposerProfileChipProps) => {
  const { profiles, isLoading, error } = useAgentProfiles({
    surface: AgentPlatformSurface.CONVERSATION,
  });
  // A bound agent's name needs the list; until it loads, or if it fails, name no agent at all.
  const isProfileNameKnown = profileKey === null || (!isLoading && !error);
  const profileName = isProfileNameKnown
    ? ComposerProfileMenuHelper.getProfileName(profiles ?? [], profileKey)
    : 'Agent';

  return (
    <span
      className={ComposerProfileMenuHelper.TRIGGER_CLASS_NAMES}
      aria-busy={isLoading}
      title={
        isProfileNameKnown
          ? `This chat runs as ${profileName}. The agent is fixed when a chat starts.`
          : 'The agent is fixed when a chat starts.'
      }
    >
      <span className="truncate">{profileName}</span>
    </span>
  );
};
